export default __webpack_public_path__ + "media/vendor/paper-dashboard-2-pro-html-v2.0.1/assets/img/flags/BO-1ef2b5068e5a796807463f0ecf76fe46.png";